import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@hooks/useTheme";
import { HomeIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useLocation } from "react-router-dom";

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { backTo } = useLocation().state || { backTo: null };

  const handleGoToHome = () => {
    navigate("/dashboard");
  };

  const handleGoBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <div data-testid="not-found-page" className={`min-h-full flex items-center justify-center ${colors.bgSecondary}`}>
      <div className={`max-w-md w-full mx-auto text-center border ${colors.bgPrimary} ${colors.borderPrimary} rounded-2xl p-8 shadow-lg`}>
        {/* 404 Icon */}
        <div>
          <div className={`mx-auto w-24 h-18 rounded-full ${colors.bgWarning} flex items-center justify-center`}>
            <span className={`text-4xl font-bold ${colors.textOnPrimary}`}>404</span>
          </div>
        </div>

        {/* Error Message */}
        <h1 className={`text-2xl font-bold mb-4 ${colors.textPrimary}`}>
          {t("notFound.title", "Page Not Found")}
        </h1>
        
        <p className={`text-base mb-8 ${colors.textSecondary}`}>
          {t("notFound.message", "The page you are looking for does not exist or has been moved.")}
        </p>

        <p className={`text-base mb-8 ${colors.textSecondary}`}>
          {t("notFound.instruction", "Please check the URL or use the navigation to find what you are looking for.")}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={handleGoToHome}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-sm transition-colors ${colors.textButton} ${colors.buttonBackgroundGradient} hover:opacity-90`}
          >
            <HomeIcon className="h-5 w-5" />
            {t("notFound.go-home", "Go to Dashboard")}
          </button>
          
          <button
            onClick={handleGoBack}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg border transition-colors ${colors.borderPrimary} ${colors.textSecondary} ${colors.hover}`}
          >
            <ArrowLeftIcon className="h-5 w-5" />
            {t("notFound.go-back", "Go Back")}
          </button>
        </div>

        {/* Additional Help */}
        <div className={`mt-8 pt-6 border-t ${colors.borderPrimary}`}>
          <p className={`text-sm ${colors.textSecondary}`}>
            {t("notFound.help", "If you believe this is an error, please contact support or try refreshing the page.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
